import { render, staticRenderFns } from "./OrderResetPage.vue?vue&type=template&id=6777562e&scoped=true"
import script from "./OrderResetPage.vue?vue&type=script&lang=js"
export * from "./OrderResetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777562e",
  null
  
)

export default component.exports